// extracted by mini-css-extract-plugin
export default {"auction-items":"auctionItems_auction-items__Cugjc"};